// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__fddoC","radio":"styles_radio__1OmLt","select":"styles_select__VIfzg"};